<template>
    <div>
        <div v-if="worksheet.dam_id">
            <div class="d-flex">
                <div class="text-muted mr-1">
                    Merlin ID:
                </div>
                <div>
                    {{worksheet.dam_id}}
                </div>
            </div>
        </div>

        <div class="d-flex">
            <div class="text-muted mr-1">
                Printable ID:
            </div>
            <div>
                {{worksheet.id}}
            </div>
        </div>

        <div v-if="worksheet.worksheet_text">
            <div class="d-flex">
                <div class="text-muted mr-1">
                    Worksheet Text:
                </div>
                <div>
                    <div v-html="worksheet.worksheet_text" class="v-html" />
                </div>
            </div>
        </div>

        <div v-if="worksheet.answer_key">
            <div class="d-flex">
                <div class="text-muted mr-1">
                    Answer Key:
                </div>
                <div>
                    <div v-html="worksheet.answer_key" class="v-html" />
                </div>
            </div>
        </div>

        <div v-if="worksheet.student_directions">
            <div class="text-muted mr-1">
                Student Directions:
            </div>
            <div>
                {{worksheet.student_directions}}
            </div>
        </div>

        <div v-if="worksheet.artist_description">
            <div class="text-muted mr-1">
                Artist Description:
            </div>
            <div>
                {{worksheet.artist_description}}
            </div>
        </div>

        <div v-if="worksheet.artist_requirements">
            <div class="text-muted mr-1">
                Artist Requirements:
            </div>
            <div>
                <div v-html="worksheet.artist_requirements" class="v-html" />
            </div>
        </div>

        <div v-if="worksheet.worksheet_suggestions">
            <div class="text-muted mr-1">
                Worksheet Suggestions:
            </div>
            <div>
                <div v-html="worksheet.worksheet_suggestions" class="v-html" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
    data: () => ({

    }),
    props: [
        'worksheet'
    ],
    components: {

    },
    computed: {

    }
}
</script>
